function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", {
  id: "title-drzave-icon"
}, "drzave");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", {
  id: "desc-drzave-icon"
}, "drzave icon");

var _ref4 =
/*#__PURE__*/
React.createElement("tspan", {
  x: 24.26,
  y: 24
}, "IN");

var _ref5 =
/*#__PURE__*/
React.createElement("tspan", {
  x: -37.21,
  y: 48
}, "HERCEGOVINA");

var _ref6 =
/*#__PURE__*/
React.createElement("tspan", {
  xmlSpace: "preserve"
}, "BOLGARIJA  ");

var _ref7 =
/*#__PURE__*/
React.createElement("tspan", {
  x: -0.54,
  y: 24
}, "GORA");

var _ref8 =
/*#__PURE__*/
React.createElement("tspan", {
  xmlSpace: "preserve"
}, "ITALIJA      ");

var SvgDrzave = function SvgDrzave(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": "title-drzave-icon desc-drzave-icon",
    viewBox: "0 0 1001.2 812.1",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", {
    id: "title-drzave-icon"
  }, title) : null, _ref3, React.createElement("path", {
    d: "M139.62,276.57l1,1c7.2,15,18.54,26.59,30.95,37.22,2.73,2.34,4.67-1,6.21-2.38,1.95-1.74-.8-2.76-1.86-3.61a338.36,338.36,0,0,1-32.49-29.46c-.78-.8-1.42-1.92-2.82-1.76a.9.9,0,0,0-1-1l-.18-.33Z",
    style: {
      fill: "#fdfdfd"
    }
  }), React.createElement("path", {
    d: "M182.57,348.63l-.36-.3.42.25c1.73,5.81,6.28,8.13,11.5,9.62C191.58,353.38,188.64,349.05,182.57,348.63Z",
    style: {
      fill: "#fdfdfd"
    }
  }), React.createElement("path", {
    d: "M272.63,430.76c21,12,42.32,12.32,64.18,8.8C316,435.19,295.66,427,272.63,430.76Z",
    style: {
      fill: "#fdfdfd"
    }
  }), React.createElement("path", {
    d: "M137.06,246.38c2-1,4.84-.16,6-2,1-1.68-1.23-3.16-2.17-4.57-3.12-4.67-6.26-9.36-9.77-13.75-7.28-9.14-7.48-9.05-13.9,1-.09.14-.2.27-.28.41-1.61,3-2.07,5.92.69,8.6,4.6,4.47,10.86,6,16.22,9.11A19.51,19.51,0,0,0,137.06,246.38Z",
    style: {
      fill: "#fdfdfd"
    }
  }), React.createElement("path", {
    d: "M116.64,281.3a98.83,98.83,0,0,0-3.15-29.71c-2.23-8.31-6-16.27-6.11-25.1,0-2.12-1.09-2.46-3-1.91-3,.87-3.44,2.77-2.48,5.38,2.8,7.59,3.56,15.46,4,23.49C106.5,263.47,108.6,273.19,116.64,281.3Z",
    style: {
      fill: "#fdfdfd"
    }
  }), React.createElement("path", {
    d: "M314.19,420.08c-10-4.91-19.56-7.33-29.87-7.32-4.19,0-6.84,2.43-7.31,5.42-.46,2.82,3,5.49,5.69,6A48.13,48.13,0,0,0,314.19,420.08Z",
    style: {
      fill: "#fdfdfd"
    }
  }), React.createElement("path", {
    d: "M338,461.7c-13.61-9.9-28.47-4.82-42.08-7.71,2.43,3.13,3.76,6.8,8,7.93C315,464.89,325.88,462.28,338,461.7Z",
    style: {
      fill: "#fdfdfd"
    }
  }), React.createElement("path", {
    d: "M149.6,332.26c6.09,10.87,12.57,21.42,26.21,27C168.54,347.47,159.75,339.24,149.6,332.26Z",
    style: {
      fill: "#fdfdfd"
    }
  }), React.createElement("path", {
    d: "M147.58,272.54c-.61-1.62-.9-2.54-1.3-3.41-1.52-3.33-3.21-6.57-6.41-8.62s-5.62,0-7.21,2.22,1.41,2.87,2.6,3.76A34.46,34.46,0,0,0,147.58,272.54Z",
    style: {
      fill: "#fdfdfd"
    }
  }), React.createElement("path", {
    d: "M353.26,475.45l29.25,8.3C373.86,477,364.56,472.56,353.26,475.45Z",
    style: {
      fill: "#fdfdfd"
    }
  }), React.createElement("path", {
    d: "M178,344.29c-2.64-5.2-6.8-8.63-12.75-11.88C168.62,338.53,172.66,342.12,178,344.29Z",
    style: {
      fill: "#fdfdfd"
    }
  }), React.createElement("path", {
    d: "M719.6.6q138.51,0,277-.1c3.43,0,4.1.67,4.1,4.1q-.18,188-.1,376c-7-.56-14.05-.47-20.87-1.77-24.1-4.6-48.25-7.66-72.88-6.73-7.06.27-14.21-1.07-21.3-2.17-16.4-2.55-32.47-7.06-49.23-7.58-8-.25-15.38,2.42-23.12,3.17-4.48.43-8.2-.85-10.08-4.73-2-4.1,1.48-6.41,4-9.14,2.81-3,6.91-7,6.58-10.18-.44-4.12-4.83-7.72-9.07-10-5-2.69-10-5.3-14.95-7.94a42.57,42.57,0,0,0-10.53-13.12c-5.58-4.72-5.18-10.43-2.49-16.65,2.16-5,6.18-4.17,10.11-4.13.34,0,.67,0,1-.05,3.52-.3,4.49-2.19,2.7-5.27-3.39-5.86-16.92-10.7-23.43-8.91-6,1.67-9.59,6.4-14,10.12-6.13,5.21-10,5.73-16.56,1.3a156.46,156.46,0,0,0-25.84-14c-9-3.86-18-7.82-27.45-10.51-1.51-.43-3.59-.9-3.22-3.12a3.77,3.77,0,0,1,3.89-3.23c1.83-.08,3.65-.44,5.47-.42,3.48,0,3.25-1.47,2.09-4-1.35-3-4.25-4.11-6.38-6.15-5.18-4.94-5.24-7.64-.15-12.82,1.88-1.91,3.85-3.86,1.94-6.9a26.36,26.36,0,0,0-6-7.19c-8.06-6.28-17.9-8.65-26.88-12.86-11.95-5.61-19.79-14.22-20.7-28.06-.31-4.8-1.27-9.55-1.7-14.35-.24-2.67-1.36-4.32-4-5-4.47-1.23-7.8-4.19-11.26-7.11-10.36-8.74-18.66-19.39-27.67-29.4,4.74-2.82,10-3.46,15.35-3.6,11.4-.29,22-3.12,31.48-9.66a21.64,21.64,0,0,1,13.66-3.73c3.1.11,6.18.3,9.23-1.27,7-3.58,10.68-9.51,11.92-16.82,1.91-11.29,7.2-20.58,15-28.73,2.41-2.52,5.24-5,6.57-8.12C699.45,32.36,711.07,17.35,719.6.6Z",
    style: {
      fill: "#ccc",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M.6,366.6c11.86,5.08,22.2,12.69,32.59,20.11s17.35,17.9,22.22,29.43c5.82,13.79,9.43,28.38,13.55,42.79a121.41,121.41,0,0,0,32.49,54.67c18.19,17.68,38.2,32.68,61,43.77,14,6.82,29.13,7.82,44.4,6.72,11.61-.83,23.12-3,34.85-2.26,4.6.27,8.27,2.5,12,4.62,2.78,1.59,3,9.55.84,12-3.5,4.15-8,6.92-12.42,9.94-4.94,3.39-8.66,7.38-7.53,14.38,1,6.11,5.21,9.15,9.75,11.68,13.42,7.45,28,12.19,42.12,18.2,12.25,5.22,24.71,9.93,36.91,15.25,11.34,5,21.09,12.67,31.56,19.13,15,9.26,29.68,19.12,44.77,28.27C410.14,701.71,420,709,428.07,718c6.4,7.11,11.29,16,11.59,26.3.06,2-.41,4.06-.05,6,1.64,8.79-3.1,14.77-8.5,20.65-1.63,1.78-2.77,1.37-4.68.7C413.33,767,405,757.86,400,745.1c-3.84-9.81-12.06-14.51-21.61-17.51-10.45-3.28-21.5-4.71-31.28-10A118.53,118.53,0,0,1,334.8,710c-4.12-2.93-8-2.49-12.1-.25a41.75,41.75,0,0,0-16.91,16.54c-7.83,14.11-15.24,28.46-19.86,44-3.14,10.6,1.59,20.1,10.75,25.92,7.79,4.94,17,6.65,24.92,11.39,1.88,1.12,3.78,2.09,5,4h-89c-2.66-9.61-4.2-19.72-8.26-28.69-4.89-10.83-9.88-22-21.91-28-6.59-3.26-13.51-4.42-20.29-6.46-11.1-3.33-22.26-6-29.57-16.69-3-4.39-4.36-8-3.47-13.14,3.08-17.64-9.71-29.76-27.36-26.46-6.92,1.29-13.45,4-21,5.43,1.66-2.58,2.9-4.55,4.18-6.48,3.54-5.34,1-11.66-5.24-13.58-5.85-1.79-11.62-2.86-17.44,0-2.83,1.37-4,0-5-2.53-4.14-10-9.09-19.61-16.38-27.79a42.9,42.9,0,0,0-19.33-12.63,87.13,87.13,0,0,0-31-4.16c-5,.28-10,.64-14.89-.8Z",
    style: {
      fill: "#ccc",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M789.73,323.51c5,2.64,10,5.25,14.95,7.94,4.24,2.3,8.63,5.9,9.07,10,.33,3.17-3.77,7.18-6.58,10.18-2.57,2.73-6,5-4,9.14,1.88,3.88,5.6,5.16,10.08,4.73,7.74-.75,15.12-3.42,23.12-3.17,16.76.52,32.83,5,49.23,7.58,7.09,1.1,14.24,2.44,21.3,2.17,24.63-.93,48.78,2.13,72.88,6.73,6.82,1.3,13.91,1.21,20.87,1.77v251c-3.5,1-6-1.14-8.51-2.89-7.71-5.37-16-8.62-25.59-8.12-5.54.29-10.31-2.3-14.85-5.11-3.39-2.09-6.61-4.46-9.86-6.77-12.64-9-25.94-6.8-38.66-1.09-7.53,3.38-14.92,6.3-23.1,7.19-15.69,1.69-31.43,2.92-46.85,6.58-8.4,2-16.92,3.61-25.65,2.16,1.2-6,2.73-12,3.52-18,2.74-21-4.17-38.46-19.57-52.79-10.34-9.61-20.58-19.33-30.87-29,3.66-2.6,7.33-5.18,11-7.81.93-.68,1.93-1.44,1.65-2.84-1.13-5.85-.08-12-2.5-17.69a31.45,31.45,0,0,1-1.36-21.82c.87-3,2.14-4.89,4.84-5.64,11.8-3.29,20.88-10.82,29.39-19.05,8-7.71,8.55-16.15,1.58-23.7A39.21,39.21,0,0,0,794,416.92c-13.83-6.89-22-18.37-27.27-32.31-3.42-9-5.75-18.34-1.66-27.55C770.82,344.15,780.58,334,789.73,323.51Z",
    style: {
      fill: "#ccc",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M719.6.6c-8.53,16.75-20.15,31.76-27.66,49.12-1.33,3.09-4.16,5.6-6.57,8.12-7.78,8.15-13.07,17.44-15,28.73-1.24,7.31-4.93,13.24-11.92,16.82-3.05,1.57-6.13,1.38-9.23,1.27a21.64,21.64,0,0,0-13.66,3.73c-9.46,6.54-20.08,9.37-31.48,9.66-5.36.14-10.61.78-15.35,3.6A41.4,41.4,0,0,0,568,117.49a102.17,102.17,0,0,1-14.95-.06,45.54,45.54,0,0,0-30.64,7.79,27.42,27.42,0,0,1-3,1.8c-6.86,3.39-14,7.47-21.47,7.15-7.77-.35-13.28,2.93-19.22,6.4-4.18,1-8.33,2.27-12.57,2.82a29.34,29.34,0,0,0-17.12,8.32c-2.61,2.51-5.36,4.94-8.95,6.18-12.44,4.32-24.83,2.78-37.3.08-20.13-4.35-36.43-15.75-52.15-28.12-19.93-15.68-37-35.08-60.36-46.27-2.39-1.14-4.58-2.68-6.87-4-3.73-7.61-7.1-15.43-11.29-22.78-4.37-7.66-9.37-15.06-19.69-15.39a12.36,12.36,0,0,1-2.87-.85c6.26-6.25,14.58-9,22.18-13s10.16-8.72,8.68-17A95.82,95.82,0,0,0,277.6.6Z",
    style: {
      fill: "#ccc",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M807.53,623.55c8.73,1.45,17.25-.16,25.65-2.16,15.42-3.66,31.16-4.89,46.85-6.58,8.18-.89,15.57-3.81,23.1-7.19,12.72-5.71,26-8,38.66,1.09,3.25,2.31,6.47,4.68,9.86,6.77,4.54,2.81,9.31,5.4,14.85,5.11,9.6-.5,17.88,2.75,25.59,8.12,2.51,1.75,5,3.91,8.51,2.89v30c-6.53-1.17-13.11-2.34-19.58.08a123.77,123.77,0,0,0-12.82,5.48c-9.44,4.77-18.88,4.49-28.38.44a12.66,12.66,0,0,0-10.13.08c-6,2.39-10.87,6.28-15.37,10.83s-9.78,6.84-16.25,5.11c-5.23-1.4-10.18-.23-15.16,1.26-7.25,2.17-7.35,2.36-3.16,8.79,3.26,5,6.77,9.69,3.66,16.45-1.72,3.74,1.7,7.17,6.65,6.54,6.08-.77,11.16,1.12,15.91,4.34,7.61,5.16,14.81,10.75,16.59,20.64l.06-.07c-6.1-4.31-12-8.93-18.36-12.83-7.15-4.37-14.22-9.2-23.66-6.45-3.5,1-3.62,3.34-4.61,5.64s-.44,4,1.68,5.54c4.13,3.08,7.83,6.77,12.11,9.62,3.7,2.45,4.72,5.75,4.85,9.72,0,1.56,1,3.63-1.32,4.25s-4.52,2.21-6.92-.16c-3.43-3.38-7.25-6.38-10.66-9.78-4.48-4.46-8.67-9.21-14.44-12.13-2.31-1.18-12.75-.65-13.14,1.13-.87,3.92.88,7.35,3.67,10.19.93,1,2,1.82,2.8,2.85,4,4.86,9.61,7.9,14.17,12.65a66.56,66.56,0,0,0-7.23,3.33c-2.84,1.75-4.43.68-6.77-1.32-6.57-5.61-8.92-13.5-12.13-20.91a21.92,21.92,0,0,0-8.6-10.5c-6.24-3.95-12.94-6.8-19.58-9.88a25.56,25.56,0,0,1-10.26-9.26c-1.77-2.65,1.12-6.21,1.82-9.4.11-.48.34-.94.46-1.42.56-2.3.1-3.08-2.46-2.14-6.61,2.4-12.39,5.28-16.88,11.43-4.37,6-6.21,12.43-7.58,19.21-1.72,8.47-1.41,17.29,2.84,24.71,8.86,15.46,20.25,29.21,31.53,43,3.54,4.32,8.12,7.79,10.65,13h-238c-4.32-8.7-9.12-17.08-16-24.1,2.27-.36,4.15.93,6.21,1.47,7.84,2,13.53-.54,17.39-7.53a19.8,19.8,0,0,0,2.35-12.52c-1.39-9.89,6.71-18.13,14-19.85,10.8-2.53,15.44-9.37,17.08-19.38,1.46-9,6.24-15.22,14.15-19.84,10.15-5.93,12.07-12.36,8.08-23.56-1.58-4.44-2.78-8.85-2.26-13.6,11.12-.8,22.25-1.37,33.33-2.5,5.08-.52,10.18-.58,15.25-2.14,9.63-3,16.41-9.93,24.13-15.61,9.39-6.9,19.25-11.74,31.45-9a97.69,97.69,0,0,0,13.35,1.73c10.22.83,19.21-1.51,24.75-11C793.9,627.25,799.46,623.39,807.53,623.55Z",
    style: {
      fill: "#ccc",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M277.6.6a95.82,95.82,0,0,1,2.85,10c1.48,8.27-1.16,13.06-8.68,17s-15.92,6.7-22.18,13c-5.91,2.17-8.76,6.77-9.9,12.64-.78,4-3,6.94-7.07,7.29C214.77,62,196.91,63.6,179,64.52c-16.08.82-31.61,3.24-43.85,14.55C124.9,88.55,113,89,100.63,87c-16-2.6-31.9-6.14-47.84-9.28C42.4,76,32,74.2,21.6,72.57c-7-1.1-13.88-2.81-21-3,0-21.67.1-43.34-.1-65C.47,1.17,1.18.5,4.6.5Q141.1.68,277.6.6Z",
    style: {
      fill: "#ccc",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M.6,69.6c7.12.16,14,1.87,21,3C32,74.2,42.4,76,52.79,77.69A33.79,33.79,0,0,1,40.14,90.16a47,47,0,0,0-9.91,8.34c-2.73,2.83-2.24,11,.58,11.15,4.84.26,8.88,2.06,13,4.45,3.56,2.08,4.28,4.46.78,6.39-3.8,2.09-5.66,5.53-7.86,8.8-2.46,3.65-1.31,6.09,3.08,6.17,2.87,0,3.9.95,3.75,3.73-.11,2,.18,4,.16,6-.06,5.09,1.47,9.27,5.61,12.65a147.67,147.67,0,0,1,13.13,12.26c1.62,1.69,3.76,4.22,2.8,6.53-.85,2-3.89.86-5.95,1.06-1.26.13-2.6.85-3.88,0,3.75-4.91,3.65-7.45-.83-11.52-3.94-3.58-7.61-6.86-14.09-5-4,1.16-8.9-.23-13.34-.87C17.61,158.9,8.55,159.37.6,165.6Z",
    style: {
      fill: "#ccc",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M561.6,811.6c-4-5.25-9.66-8.92-13.33-14.54a70.8,70.8,0,0,1-6-10.27c-2.94-6.75-2.67-7.27,4.45-9.81,4.48-1.59,8.79-1.75,12.93.76,3.59,2.17,3.85,4.31.5,6.82-3.08,2.32-3.34,4.64-2,8.15,2.79,7.59,8.3,13.1,13.5,18.89Z",
    style: {
      fill: "#ccc",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M1000.6,773.6l-2.45-4.69c-2.76,1.17-4.1,4.51-7.64,4.71-5,.29-7.52-1.47-7.8-6.49-.34-6.12,2.31-9.56,7.08-9.61,3.66,0,7.11,1.81,10.81,1.08Z",
    style: {
      fill: "#ccc",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M283.44,79.54c2.29,1.36,4.48,2.9,6.87,4,23.38,11.19,40.43,30.59,60.36,46.27,15.72,12.37,32,23.77,52.15,28.12,12.47,2.7,24.86,4.24,37.3-.08,3.59-1.24,6.34-3.67,8.95-6.18a29.34,29.34,0,0,1,17.12-8.32c4.24-.55,8.39-1.86,12.57-2.82-1.71,7.49-2.85,15.08-1.09,22.67,1.6,6.88,2.71,14.33,9.27,18.57,4.66,3,5.48,6,1.75,10.09-2.49,2.7-1.64,4.57.63,7.07,5.61,6.17,13.56,8.2,20.37,12.22,3.74,2.22,7.86,7.7,7,9.87-1.21,3.13-6.45,4.1-12.08,2.25-7.05-2.31-8.53-1.59-10.78,5.63a55.77,55.77,0,0,0-1.21,6.36c-1.28,6.84-2.06,13.8-4.88,20.27-5.21,2.09-9.73.83-13.67-2.92a96.57,96.57,0,0,1-7.79-7.75c-8.78-10.52-21-14.19-33.53-14-26.77.53-53.19-2-79.62-5.47-11.86-1.54-24-2-33.69-10.53-1.82-1.59-4-1.24-6.52-.29-8.16,3.15-16.11,7.24-25.45,5.77-4.12-.64-7.32,1.81-9.48,5.31-1.14,1.84-2,3.87-3.09,5.71-4.79,7.8-13.62,8.64-19.69,1.92a37.43,37.43,0,0,0-15.91-10.74c-8.24-2.81-12.9-.65-15.87,7.63a52.63,52.63,0,0,0-2.66,21.16c.37,5.88,1.44,12.09,4.75,17.11A84.77,84.77,0,0,0,238,283.43c9.76,9.21,17,19.95,19.79,33.34A46.4,46.4,0,0,0,272,342.07c6.27,5.73,12.8,11.17,19,16.92,16.67,15.32,34.43,29.43,50.3,45.64a20.93,20.93,0,0,1,6.3,12.6,21,21,0,0,0,6.84,12.95c5.44,5.16,10.78,10.42,16.15,15.65,6.74,6.57,6.75,6.83.71,13.56-12.92-8.67-23.94-19.59-35.2-30.17-12-11.25-25.18-19.6-41.44-23.66-11.87-3-23.54-5.36-35.82-5.27-10.31.08-19-3.8-25.11-12.7-9.15-13.28-22.58-22-34.95-31.77a115.64,115.64,0,0,1-27.51-31.27c-1.37-2.27-1.51-3.21,1.48-4a66.25,66.25,0,0,1,22.73-1.82c.11.51.33.74.79.28l-.63-.44a162.14,162.14,0,0,0-20.33-18.28c-16.76-13.05-23.3-31-25.59-51-1.16-10.14-5.26-18.32-13.17-24.78-5.27-4.31-10.33-8.91-15.3-13.58a25.45,25.45,0,0,0-9-5.19c-3.9-1.41-9.29.76-11.57,4.3a79,79,0,0,0-9.8,20.65c-2.16,7.45-5.91,14.08-9.79,20.67s-14.63,7.39-19.6,1.78C51,241.26,46.37,226.85,42.46,212c-2.3-8.78-3-17.22.95-25.63,6.18,6.22,14.06,7.69,22.37,8.15,3.61.2,6.62-.3,8.23-4,.58-1.34,1.68-2.19,3.2-1.68,8.34,2.8,16.85.47,25.27.82,6.79.27,11.86-2.43,14.34-9.18a30.27,30.27,0,0,1,3.37-6.67c2-2.91,4.41-3.94,7-.29,2.38,3.41,4.85,6.77,7.42,10,3.65,4.64,8.45,6.37,14.18,4.8a16.68,16.68,0,0,1,10.24.58c5,1.76,9.69,4.42,15,5.37a11.65,11.65,0,0,0,10.18-2.66c3.12-2.7.59-5.31-.22-8.1s-2.62-6.28.73-8.21c5.43-3.11,3.75-5.51,0-8.33-3.26-2.46-3.07-4.46.48-6.82,5.38-3.56,11.71-3.48,17.53-5.27,4.5-1.38,7.78-3.48,9.85-8.14,3.07-6.89.71-13-1.41-19.22-3.76-11.06-1.17-15.84,8.46-20.41s19.57-8.42,28.81-13.77a8,8,0,0,1,6.18-.93c6.6,1.6,8,.24,6.35-6.26-1-3.8.21-5.85,3.72-7.43C271.16,75.75,277.29,77.07,283.44,79.54Z",
    style: {
      fill: "#febd17",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M371.32,459.39c6-6.73,6-7-.71-13.56-5.37-5.23-10.71-10.49-16.15-15.65a21,21,0,0,1-6.84-12.95,20.93,20.93,0,0,0-6.3-12.6C325.45,388.42,307.69,374.31,291,359c-6.25-5.75-12.78-11.19-19-16.92a46.4,46.4,0,0,1-14.15-25.3c-2.83-13.39-10-24.13-19.79-33.34a84.77,84.77,0,0,1-12.49-14.9c-3.31-5-4.38-11.23-4.75-17.11a52.63,52.63,0,0,1,2.66-21.16c3-8.28,7.63-10.44,15.87-7.63a37.43,37.43,0,0,1,15.91,10.74c6.07,6.72,14.9,5.88,19.69-1.92,1.13-1.84,1.95-3.87,3.09-5.71,2.16-3.5,5.36-6,9.48-5.31,9.34,1.47,17.29-2.62,25.45-5.77,2.47-.95,4.7-1.3,6.52.29,9.71,8.51,21.83,9,33.69,10.53,26.43,3.43,52.85,6,79.62,5.47,12.49-.24,24.75,3.43,33.53,14a96.57,96.57,0,0,0,7.79,7.75c3.94,3.75,8.46,5,13.67,2.92,4.86.27,9.54-1.08,14.31-1.58,2.61-.27,5.68-2,7.72,1.2s3.46,6.06,1.16,10.09c-2.79,4.88-4.43,10.39-6.85,15.49a67.47,67.47,0,0,0-6.36,25.88c-.07,1.49-.36,3.05.85,4.26,3.28,3.29,5.91,7.42,10.08,9.59,7.08,3.68,12.66,8.86,17.74,14.92a26.84,26.84,0,0,1,5,9c.64,1.95.05,3.24-2.3,3.28-4.23.07-8.1,1.74-12,3-8.13,2.51-7.85,2.45-3.3,9.78s10.68,14.11,13,22.87c2,7.86-2.51,12.62-10.33,10.72-5.1-1.25-9.88-1.73-13.1,3.62-3.66-.12-7.37.11-10.95-.47s-6.28-.19-8.14,3.06.83,4.94,2.45,6.84c2.33,2.71,3.67,5.84,2.46,9.12-1.38,3.7-4.91,3.66-8.43,3.6-5.59-.08-10.81.34-15.7,4.48-5.93,5-7.21,11.12-7.42,18.12-.23,7.53-1.16,8.45-8.42,9.4-6.24.81-7.38,2.47-7.71,8.66s1.94,11.69,4.16,17.26c4.24,10.66,3.72,12.81-4.49,20.61a3,3,0,0,1-.42.27c-15-7.29-28.23-17.36-41.43-27.35-6.43-4.86-13.37-6.77-21-7.37Z",
    style: {
      fill: "#febd17",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M647.66,672.69c-.52,4.75.68,9.16,2.26,13.6,4,11.2,2.07,17.63-8.08,23.56-7.91,4.62-12.69,10.88-14.15,19.84-1.64,10-6.28,16.85-17.08,19.38-7.33,1.72-15.43,10-14,19.85a19.8,19.8,0,0,1-2.35,12.52c-3.86,7-9.55,9.57-17.39,7.53-2.06-.54-3.94-1.83-6.21-1.47l0,.08c0-.88-.64-.81-1.23-.8-3.23-6.29-3.86-13.34-5.88-20a13.11,13.11,0,0,0-3.86-6.21c-8.17-7.34-16.18-14.9-25.7-20.51-9-5.28-13.49-14.45-20.94-22.7l9.2,2.15C523.54,714,522,708.92,520,704a42.22,42.22,0,0,1-1.47-28.71c4.28-14.71,7-29.65,6.63-45.19-.28-13.21,4.39-25.8,7.19-38.61,1.43-6.58,1.21-12.71-4.28-17.82-2-1.91-4.32-2.28-6.69-2.86-2.53-.63-5.34-.21-7.52-2.09,1.54-3.37.95-6.83.22-10.2-2.58-11.92-3.4-23.6,3.81-34.41,7.07-10.61,15.24-20.47,21.48-31.63a2.45,2.45,0,0,1,.67-.73c1.3-1,2.6-2.36,4.4-1.6a3.91,3.91,0,0,1,2.28,4.08c0,1.16.11,2.34,0,3.48-.44,3.23,1,4.86,4.06,5.76,8.45,2.52,15.95-.32,23.35-3.87,2.45,3.53,5.12,6.93,7.28,10.62,3,5.16,6.88,9.39,12.28,12,15.08,7.18,25.23,28.26,21.45,45.4-.83,2.68-1.47,5.44-2.53,8-3.79,9.2-4.85,18.94-5.81,28.68-2,20.44,5.89,38,16.21,54.85,2.48,4,6.14,5.93,10.66,6.44C639.19,666.22,644.39,667.52,647.66,672.69Z",
    style: {
      fill: "#ccc",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M283.44,79.54c-6.15-2.47-12.28-3.79-18.78-.86-3.51,1.58-4.68,3.63-3.72,7.43,1.64,6.5.25,7.86-6.35,6.26a8,8,0,0,0-6.18.93c-9.24,5.35-19.19,9.22-28.81,13.77s-12.22,9.35-8.46,20.41c2.12,6.21,4.48,12.33,1.41,19.22-2.07,4.66-5.35,6.76-9.85,8.14-5.82,1.79-12.15,1.71-17.53,5.27-3.55,2.36-3.74,4.36-.48,6.82,3.75,2.82,5.43,5.22,0,8.33-3.35,1.93-1.51,5.52-.73,8.21s3.34,5.4.22,8.1A11.65,11.65,0,0,1,174,194.23c-5.32-.95-10-3.61-15-5.37a16.68,16.68,0,0,0-10.24-.58c-5.73,1.57-10.53-.16-14.18-4.8-2.57-3.27-5-6.63-7.42-10-2.55-3.65-4.94-2.62-7,.29a30.27,30.27,0,0,0-3.37,6.67c-2.48,6.75-7.55,9.45-14.34,9.18-8.42-.35-16.93,2-25.27-.82-1.52-.51-2.62.34-3.2,1.68-1.61,3.73-4.62,4.23-8.23,4-8.31-.46-16.19-1.93-22.37-8.15,4.07-2.77,8.52-5,12-8.64,1.28.85,2.62.13,3.88,0,2.06-.2,5.1,1,5.95-1.06,1-2.31-1.18-4.84-2.8-6.53a147.67,147.67,0,0,0-13.13-12.26c-4.14-3.38-5.67-7.56-5.61-12.65,0-2-.27-4-.16-6,.15-2.78-.88-3.68-3.75-3.73-4.39-.08-5.54-2.52-3.08-6.17,2.2-3.27,4.06-6.71,7.86-8.8,3.5-1.93,2.78-4.31-.78-6.39-4.07-2.39-8.11-4.19-12.95-4.45-2.82-.15-3.31-8.32-.58-11.15a47,47,0,0,1,9.91-8.34A33.79,33.79,0,0,0,52.79,77.69C68.73,80.83,84.6,84.37,100.63,87c12.34,2,24.27,1.58,34.54-7.9C147.41,67.76,162.94,65.34,179,64.52c17.89-.92,35.75-2.54,53.6-4.07,4.08-.35,6.29-3.27,7.07-7.29,1.14-5.87,4-10.47,9.9-12.64a12.36,12.36,0,0,0,2.87.85c10.32.33,15.32,7.73,19.69,15.39C276.34,64.11,279.71,71.93,283.44,79.54Z",
    style: {
      fill: "#febd17",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M574.07,499.62c-7.4,3.55-14.9,6.39-23.35,3.87-3-.9-4.5-2.53-4.06-5.76.15-1.14,0-2.32,0-3.48a3.91,3.91,0,0,0-2.28-4.08c-1.8-.76-3.1.59-4.4,1.6a2.45,2.45,0,0,0-.67.73c-6.24,11.16-14.41,21-21.48,31.63-7.21,10.81-6.39,22.49-3.81,34.41.73,3.37,1.32,6.83-.22,10.2C497.79,558,486.34,542.38,472.77,529c-4.5-4.42-9-8.92-12.22-14.41-1.83-3.11-4-4.39-7.75-3.54-2.11.49-4.57,1.35-6.67-.44-.34-.6-.64-1.26-1.53-1.12l.07.05c-1.06-3.75-3.64-6.95-4-11a3,3,0,0,0,.42-.27c8.21-7.8,8.73-9.95,4.49-20.61-2.22-5.57-4.49-11-4.16-17.26s1.47-7.85,7.71-8.66c7.26-.95,8.19-1.87,8.42-9.4.21-7,1.49-13.09,7.42-18.12,4.89-4.14,10.11-4.56,15.7-4.48,3.52.06,7.05.1,8.43-3.6,1.21-3.28-.13-6.41-2.46-9.12-1.62-1.9-4.26-3.65-2.45-6.84s4.61-3.64,8.14-3.06,7.29.35,10.95.47c1.29,7.63,6.13,13.13,11.35,18.22,14.75,14.4,32.54,23.64,51.75,30.66,12.61,4.61,25.32,9.57,30.2,24.08-6.1,1.95-12.18,3.95-18.3,5.83S571.4,479.6,573,486C574.17,490.48,575.17,495,574.07,499.62Z",
    style: {
      fill: "#febd17",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M440.71,498.6c.32,4,2.9,7.22,4,11-9.62-4.23-18.17-10.33-27-15.87-18.06-11.35-36.41-22.18-56.06-30.52-8.85-3.75-18.23-6.26-27.37-9.33a20.86,20.86,0,0,1-5.11-2.22c4.93-.73,9.76-1.54,14.79-.27,9.62,2.44,18.31,7,27.09,11.38,2.38,1.18,4.6,2.72,7.3,3.16.32.41.66.81,1.11.17,0-.05-.42-.42-.64-.64-.17-.52-.35-1-.52-1.55,7.65.6,14.59,2.51,21,7.37C412.48,481.24,425.7,491.31,440.71,498.6Z",
    style: {
      fill: "#febd17",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M272.63,430.76c23-3.79,43.34,4.43,64.18,8.8C315,443.08,293.59,442.75,272.63,430.76Z",
    style: {
      fill: "#febd17",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M137.06,246.38a19.51,19.51,0,0,1-3.23-1.21c-5.36-3.12-11.62-4.64-16.22-9.11-2.76-2.68-2.3-5.59-.69-8.6.08-.14.19-.27.28-.41,6.42-10.08,6.62-10.17,13.9-1,3.51,4.39,6.65,9.08,9.77,13.75.94,1.41,3.18,2.89,2.17,4.57C141.9,246.22,139.05,245.41,137.06,246.38Z",
    style: {
      fill: "#febd17",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M116.64,281.3c-8-8.11-10.14-17.83-10.69-27.85-.45-8-1.21-15.9-4-23.49-1-2.61-.51-4.51,2.48-5.38,1.87-.55,2.93-.21,3,1.91.13,8.83,3.88,16.79,6.11,25.1A98.83,98.83,0,0,1,116.64,281.3Z",
    style: {
      fill: "#febd17",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M314.19,420.08a48.13,48.13,0,0,1-31.49,4.12c-2.7-.53-6.15-3.2-5.69-6,.47-3,3.12-5.41,7.31-5.42C294.63,412.75,304.17,415.17,314.19,420.08Z",
    style: {
      fill: "#febd17",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M140.6,277.6c1.4-.16,2,1,2.82,1.76a338.36,338.36,0,0,0,32.49,29.46c1.06.85,3.81,1.87,1.86,3.61-1.54,1.37-3.48,4.72-6.21,2.38-12.41-10.63-23.75-22.22-30.95-37.22Z",
    style: {
      fill: "#febd17",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M338,461.7c-12.13.58-23,3.19-34.11.22-4.21-1.13-5.54-4.8-8-7.93C309.54,456.88,324.4,451.8,338,461.7Z",
    style: {
      fill: "#febd17",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M149.6,332.26c10.15,7,18.94,15.21,26.21,27C162.17,353.68,155.69,343.13,149.6,332.26Z",
    style: {
      fill: "#febd17",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M147.58,272.54a34.46,34.46,0,0,1-12.32-6.05c-1.19-.89-4.26-1.42-2.6-3.76s4-4.26,7.21-2.22,4.89,5.29,6.41,8.62C146.68,270,147,270.92,147.58,272.54Z",
    style: {
      fill: "#febd17",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M353.26,475.45c11.3-2.89,20.6,1.52,29.25,8.3Z",
    style: {
      fill: "#febd17",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M182.57,348.64c6.07.41,9,4.74,11.56,9.56-5.22-1.49-9.77-3.81-11.5-9.62Z",
    style: {
      fill: "#febd17",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M178,344.29c-5.32-2.17-9.36-5.76-12.75-11.88C171.18,335.66,175.34,339.09,178,344.29Z",
    style: {
      fill: "#febd17",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("polygon", {
    points: "139.62 276.57 139.38 276.3 139.56 276.63 139.62 276.57",
    style: {
      fill: "#6598fe"
    }
  }), React.createElement("path", {
    d: "M140.61,277.59l-1-1-.06.06a.9.9,0,0,1,1,1Z",
    style: {
      fill: "#6598fe"
    }
  }), React.createElement("path", {
    d: "M444.6,509.52c.89-.14,1.19.52,1.53,1.12C445.42,510.55,444.78,510.35,444.6,509.52Z",
    style: {
      fill: "#6598fe"
    }
  }), React.createElement("path", {
    d: "M182.63,348.58l-.42-.25.36.3Z",
    style: {
      fill: "#6598fe"
    }
  }), React.createElement("path", {
    d: "M569.44,786.78c.59,0,1.23-.08,1.23.8Z",
    style: {
      fill: "#6598fe"
    }
  }), React.createElement("path", {
    d: "M596.62,470.61c-4.88-14.51-17.59-19.47-30.2-24.08-19.21-7-37-16.26-51.75-30.66-5.22-5.09-10.06-10.59-11.35-18.22,3.22-5.35,8-4.87,13.1-3.62,7.82,1.9,12.38-2.86,10.33-10.72-2.29-8.76-8.34-15.44-13-22.87s-4.83-7.27,3.3-9.78c3.95-1.22,7.82-2.89,12-3,2.35,0,2.94-1.33,2.3-3.28a26.84,26.84,0,0,0-5-9c-5.08-6.06-10.66-11.24-17.74-14.92-4.17-2.17-6.8-6.3-10.08-9.59-1.21-1.21-.92-2.77-.85-4.26a67.47,67.47,0,0,1,6.36-25.88c2.42-5.1,4.06-10.61,6.85-15.49,2.3-4,.86-7-1.16-10.09s-5.11-1.47-7.72-1.2c-4.77.5-9.45,1.85-14.31,1.58,2.82-6.47,3.6-13.43,4.88-20.27a55.77,55.77,0,0,1,1.21-6.36c2.25-7.22,3.73-7.94,10.78-5.63,5.63,1.85,10.87.88,12.08-2.25.84-2.17-3.28-7.65-7-9.87-6.81-4-14.76-6.05-20.37-12.22-2.27-2.5-3.12-4.37-.63-7.07,3.73-4.05,2.91-7.07-1.75-10.09-6.56-4.24-7.67-11.69-9.27-18.57-1.76-7.59-.62-15.18,1.09-22.67,5.94-3.47,11.45-6.75,19.22-6.4,7.43.32,14.61-3.76,21.47-7.15a27.42,27.42,0,0,0,3-1.8,45.54,45.54,0,0,1,30.64-7.79,102.17,102.17,0,0,0,14.95.06,41.4,41.4,0,0,1,20.73,4.16c9,10,17.31,20.66,27.67,29.4,3.46,2.92,6.79,5.88,11.26,7.11,2.59.72,3.71,2.37,4,5,.43,4.8,1.39,9.55,1.7,14.35.91,13.84,8.75,22.45,20.7,28.06,9,4.21,18.82,6.58,26.88,12.86a26.36,26.36,0,0,1,6,7.19c1.91,3-.06,5-1.94,6.9-5.09,5.18-5,7.88.15,12.82,2.13,2,5,3.19,6.38,6.15,1.16,2.53,1.39,4-2.09,4-1.82,0-3.64.34-5.47.42a3.77,3.77,0,0,0-3.89,3.23c-.37,2.22,1.71,2.69,3.22,3.12,9.47,2.69,18.43,6.65,27.45,10.51a156.46,156.46,0,0,1,25.84,14c6.61,4.43,10.43,3.91,16.56-1.3,4.38-3.72,7.93-8.45,14-10.12,6.51-1.79,20,3.05,23.43,8.91,1.79,3.08.82,5-2.7,5.27-.33,0-.66.05-1,.05-3.93,0-8-.85-10.11,4.13-2.69,6.22-3.09,11.93,2.49,16.65a42.57,42.57,0,0,1,10.53,13.12c-9.15,10.49-18.91,20.64-24.63,33.55-4.09,9.21-1.76,18.56,1.66,27.55,5.3,13.94,13.44,25.42,27.27,32.31a39.21,39.21,0,0,1,11.14,8.26c7,7.55,6.39,16-1.58,23.7-8.51,8.23-17.59,15.76-29.39,19.05-2.7.75-4,2.66-4.84,5.64a31.45,31.45,0,0,0,1.36,21.82c2.42,5.69,1.37,11.84,2.5,17.69.28,1.4-.72,2.16-1.65,2.84-3.63,2.63-7.3,5.21-11,7.81a62.83,62.83,0,0,1-6.73-1.62c-4.43-1.57-8.78-2.42-13.52-1.3a221.13,221.13,0,0,0-23.42,6.45c-6.59,2.34-13.56,2.77-20.48,3.28-1.87-7.27-.14-13.65,4.38-19.57a103.13,103.13,0,0,0,6-9.79c5-8.4,1.62-16.24-7.87-17.62-8.37-1.22-15.53-3.69-18.27-12.83a11.24,11.24,0,0,0-2.44-3.74c-11.45-13.29-23.67-25.81-38.8-34.93-8.7-5.24-12-4.48-18.41,1.78-1.55,1.5-2.27,2.92-.92,4.75,3.46,4.71,1.29,8.08-2.64,10.89-4.46,3.18-8.26,6.95-9.43,12.43C606.68,468.29,602.64,470.62,596.62,470.61Z",
    style: {
      fill: "#febd17",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M696.46,530.54c6.92-.51,13.89-.94,20.48-3.28a221.13,221.13,0,0,1,23.42-6.45c4.74-1.12,9.09-.27,13.52,1.3a62.83,62.83,0,0,0,6.73,1.62c10.29,9.67,20.53,19.39,30.87,29,15.4,14.33,22.31,31.82,19.57,52.79-.79,6.06-2.32,12-3.52,18-8.07-.16-13.63,3.7-17.61,10.55-5.54,9.54-14.53,11.88-24.75,11a97.69,97.69,0,0,1-13.35-1.73c-12.2-2.72-22.06,2.12-31.45,9-7.72,5.68-14.5,12.65-24.13,15.61-5.07,1.56-10.17,1.62-15.25,2.14-11.08,1.13-22.21,1.7-33.33,2.5-3.27-5.17-8.47-6.47-14-7.09-4.52-.51-8.18-2.4-10.66-6.44-10.32-16.84-18.22-34.41-16.21-54.85,1-9.74,2-19.48,5.81-28.68,1.06-2.58,1.7-5.34,2.53-8,3.91,2.69,8.58,2.26,11.2-1a97.8,97.8,0,0,0,9-13.77,21.35,21.35,0,0,1,3.82-4.5c7.28-7.3,15.9-8,25.43-6.16,4.24.82,9.18,2,12.36-2.57,3.39-4.87,7.94-7.21,13.74-7.7A38.67,38.67,0,0,0,696.46,530.54Z",
    style: {
      fill: "#febd17",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M74.81,684c-2.88,1.31-4.19,3.57-6.19,2.85-2.16-.77-.86-3.07-1.63-5.24Z",
    style: {
      fill: "#ccc",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M948.51,698.73c-6-.16-10.08-3.73-10-8.66.08-5.8,4.85-10.71,10.17-10.46,4.77.23,11.5,5.23,11.44,8.51C960,693.63,954.26,698.89,948.51,698.73Z",
    style: {
      fill: "#ccc",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M922.56,741.64l.53.32c-.09,0-.23,0-.27,0a1.65,1.65,0,0,1-.2-.37Z",
    style: {
      fill: "#6598fe"
    }
  }), React.createElement("path", {
    d: "M195.66,318.54l.63.44c-.46.46-.68.23-.79-.28Z",
    style: {
      fill: "#fdfdfd"
    }
  }), React.createElement("path", {
    d: "M696.46,530.54a38.67,38.67,0,0,1-5.79,1.39c-5.8.49-10.35,2.83-13.74,7.7-3.18,4.55-8.12,3.39-12.36,2.57-9.53-1.83-18.15-1.14-25.43,6.16a21.35,21.35,0,0,0-3.82,4.5,97.8,97.8,0,0,1-9,13.77c-2.62,3.24-7.29,3.67-11.2,1,3.78-17.14-6.37-38.22-21.45-45.4-5.4-2.58-9.25-6.81-12.28-12-2.16-3.69-4.83-7.09-7.28-10.62,1.1-4.66.1-9.14-1.05-13.65-1.62-6.37-.77-7.67,5.3-9.53s12.2-3.88,18.3-5.83c6,0,10.06-2.32,11.42-8.7,1.17-5.48,5-9.25,9.43-12.43,3.93-2.81,6.1-6.18,2.64-10.89-1.35-1.83-.63-3.25.92-4.75,6.44-6.26,9.71-7,18.41-1.78,15.13,9.12,27.35,21.64,38.8,34.93a11.24,11.24,0,0,1,2.44,3.74c2.74,9.14,9.9,11.61,18.27,12.83,9.49,1.38,12.86,9.22,7.87,17.62a103.13,103.13,0,0,1-6,9.79C696.32,516.89,694.59,523.27,696.46,530.54Z",
    style: {
      fill: "#febd17",
      stroke: "#666",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "M378.78,465.43c.22.22.67.59.64.64-.45.64-.79.24-1.11-.17Z",
    style: {
      fill: "#fdfdfd"
    }
  }), React.createElement("text", {
    transform: "translate(806.31 201.66)",
    style: {
      fontSize: 20,
      fill: "#fff",
      fontFamily: "OpenSans-Extrabold, Open Sans",
      fontWeight: 800
    }
  }, "ROMUNIJA"), React.createElement("text", {
    transform: "translate(392.57 67.38)",
    style: {
      fontSize: 20,
      fill: "#fff",
      fontFamily: "OpenSans-Extrabold, Open Sans",
      fontWeight: 800
    }
  }, "MAD\u017DARSKA"), React.createElement("text", {
    transform: "translate(58.4 39.1)",
    style: {
      fontSize: 20,
      fill: "#fff",
      fontFamily: "OpenSans-Extrabold, Open Sans",
      fontWeight: 800
    }
  }, "AVSTRIJA"), React.createElement("text", {
    transform: "translate(77.55 130.75)",
    style: {
      fontSize: 20,
      fill: "#fff",
      fontFamily: "OpenSans-Extrabold, Open Sans",
      fontWeight: 800
    }
  }, "SLOVENIJA"), React.createElement("text", {
    transform: "translate(227.93 183.11)",
    style: {
      fontSize: 20,
      fill: "#fff",
      fontFamily: "OpenSans-Extrabold, Open Sans",
      fontWeight: 800
    }
  }, "HRVA\u0160KA"), React.createElement("text", {
    transform: "translate(355.94 301.6)",
    style: {
      fontSize: 20,
      fill: "#fff",
      fontFamily: "OpenSans-Extrabold, Open Sans",
      fontWeight: 800
    }
  }, "BOSNA", _ref4, _ref5), React.createElement("text", {
    transform: "translate(605.75 345.65)",
    style: {
      fontSize: 20,
      fill: "#fff",
      fontFamily: "OpenSans-Extrabold, Open Sans",
      fontWeight: 800
    }
  }, "SRBIJA"), React.createElement("text", {
    transform: "translate(855.83 465.43)",
    style: {
      fontSize: 20,
      fill: "#fff",
      fontFamily: "OpenSans-Extrabold, Open Sans",
      fontWeight: 800
    }
  }, _ref6), React.createElement("text", {
    transform: "translate(636.24 603.74)",
    style: {
      fontSize: 20,
      fill: "#fff",
      fontFamily: "OpenSans-Extrabold, Open Sans",
      fontWeight: 800
    }
  }, "MAKEDONIJA"), React.createElement("text", {
    transform: "translate(597.1 513.02)",
    style: {
      fontSize: 20,
      fill: "#fff",
      fontFamily: "OpenSans-Extrabold, Open Sans",
      fontWeight: 800
    }
  }, "KOSOVO"), React.createElement("text", {
    transform: "translate(469.73 461.97)",
    style: {
      fontSize: 20,
      fill: "#fff",
      fontFamily: "OpenSans-Extrabold, Open Sans",
      fontWeight: 800
    }
  }, "\u010CRNA", _ref7), React.createElement("text", {
    transform: "translate(526.2 695.56)",
    style: {
      fontSize: 20,
      fill: "#fff",
      fontFamily: "OpenSans-Extrabold, Open Sans",
      fontWeight: 800
    }
  }, "ROMUNIJA"), React.createElement("text", {
    transform: "translate(682.64 751.82)",
    style: {
      fontSize: 20,
      fill: "#fff",
      fontFamily: "OpenSans-Extrabold, Open Sans",
      fontWeight: 800
    }
  }, "GR\u010CIJA"), React.createElement("text", {
    transform: "translate(109.48 636.2)",
    style: {
      fontSize: 20,
      fill: "#fff",
      fontFamily: "OpenSans-Extrabold, Open Sans",
      fontWeight: 800
    }
  }, _ref8));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDrzave, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/drzave.76d8e94a.svg";
export { ForwardRef as ReactComponent };